import desygnerApi from '../factory/desygner-api';
import SocketClient from './socket';

/*
 * Deprecation TODO
 *  this file duplicates lib/extended/background-removal-manager.js
 *  please, consider switching to a unified version before modifying
 */
class BackgroundRemovalManager {
  constructor () {
    this._processing = {};
    this._subscriptions = {};
    this._intervals = {};
    this._failed = {};
  }

  removeBackground (image, processResizing = true) {
    if (!this._processing[image] || this._failed[image]) {
      this._failed[image] = false;
      this._processing[image] = (async () => {
        let endpoint = 'business';

        if (INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.domain) {
          endpoint = `brand/companies/${INKIVE.C.WHITE_LABEL_CONFIGURATION.domain}`;
        }

        const response = await desygnerApi.post(`${endpoint}/background-removal`, {
          image, generate_versions: true
        });

        await Promise.any([
          this._socketUpdate(image, response),
          this._s3PingUpdate(image, response),
          this._removalTimeout(image)
        ]);

        this._unsubscribe(image);

        if (this._failed[image]) {
          throw new Error();
        }

        if (processResizing) {
          await this._processResizing(response.expected_output);
        }

        return response.expected_output;
      })();
    }

    return this._processing[image];
  }

  async removeBackgroundAndEdit (image, processResizing = true) {
    const endpoint = INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.domain
      ? `brand/companies/${INKIVE.C.WHITE_LABEL_CONFIGURATION.domain}`
      : 'business';
    const response = await desygnerApi.post(`${endpoint}/background-removal?edit`, {
      image,
      edit: true,
      generate_versions: true
    });
    const socketResponse = await Promise.any([
      this._socketUpdate(image, response),
      this._removalTimeout(image)
    ]);

    this._unsubscribe(image);

    if (!socketResponse) throw new Error('Background removal failed');
    if (!socketResponse.id || !socketResponse.secret) throw new Error('Invalid response from background removal');

    return socketResponse;
  }

  _processResizing (original) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();

      let match = original.match(/[^/]*\.(inkive|webrand|desygner)\.com/);
      const bucket = match && match[0];
      match = match && original.split(bucket);
      const key = match && match[1];

      if (bucket && key) {
        const data = `key=${encodeURIComponent(key)}&bucket=${bucket}&type=editor&scrapbookId=${INKIVE.C.BOOK.id}`;

        xhr.open('POST', `${INKIVE.C.BASE_URL}upload/successasync`);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(data);
        xhr.onload = resolve;
      } else {
        resolve();
      }
    });
  }

  _socketUpdate (image, response) {
    return new Promise(resolve => {
      const socketClient = new SocketClient();
      this._subscriptions[image] = socketClient.openChannel({
        disposeOnMessage: true,
        successCallback: resolve,
        channelId: `background_removal_${response.id}`
      });
    });
  }

  _s3PingUpdate (image, response) {
    return new Promise(resolve => {
      const someInterval = 6 * 1000;

      this._intervals[image] = setInterval(() => {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 2 && xhr.status === 200) {
            xhr.abort();
            resolve();
          }
        };

        xhr.open('GET', response.expected_output, true);
        xhr.send();
      }, someInterval);
    });
  }

  _removalTimeout (image) {
    const twoMinutes = 2 * 60 * 1000;

    return new Promise(resolve => setTimeout(() => {
      this._failed[image] = true;
      resolve();
    }, twoMinutes));
  }

  _unsubscribe (image) {
    clearInterval(this._intervals[image]);
    this._subscriptions[image] && this._subscriptions[image].dispose();
  }
}

module.exports = new BackgroundRemovalManager();
